import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface SlideNavigationProps {
  currentSlide: number;
  totalSlides: number;
  onBack: () => void;
  onNext: () => void;
  hideNext?: boolean;
}
export function SlideNavigation({
  currentSlide,
  totalSlides,
  onBack,
  onNext,
  hideNext
}: SlideNavigationProps) {
  if (currentSlide === 0) return null;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-4 px-6 py-3 bg-white/80 backdrop-blur-md border border-neutral-200/50 shadow-lg shadow-black/5 rounded-full" data-id="element-249">
      <button onClick={onBack} disabled={currentSlide === 0} className={`p-2 rounded-full transition-colors ${currentSlide === 0 ? 'text-neutral-300 cursor-not-allowed' : 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900'}`} aria-label="Previous slide" data-id="element-250">
        <ChevronLeftIcon className="w-6 h-6" data-id="element-251" />
      </button>

      <div className="text-sm font-medium text-neutral-500 min-w-[4rem] text-center" data-id="element-252">
        {currentSlide} / {totalSlides - 1}
      </div>

      {!hideNext ? <button onClick={onNext} disabled={currentSlide === totalSlides - 1} className={`p-2 rounded-full transition-colors ${currentSlide === totalSlides - 1 ? 'text-neutral-300 cursor-not-allowed' : 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900'}`} aria-label="Next slide" data-id="element-253">
            <ChevronRightIcon className="w-6 h-6" data-id="element-254" />
          </button> : <div className="w-10 h-10" data-id="element-255" /> // Placeholder to maintain centering
    }
    </motion.div>;
}